import { BLOCK_TYPES as e, DEFAULT_ALIGNMENT as t, HORIZONTAL_RULE_FALLBACK as n, NO_MARGIN_CLASS as r } from "./constants.js";
import { BlocksDocument as i } from "./blocks-document.js";
import { escape as a } from "./utils/escape.js";
import { TextSerializer as o } from "./text-serializer.js";
//#region src/blocks-serializer.ts
var s = class {
	config;
	schema;
	customHandlers;
	fallbackNodeTypeName;
	constructor(e, t) {
		this.config = e, this.schema = t, this.customHandlers = /* @__PURE__ */ new Map();
		for (let t of e.customBlockHandlers ?? []) this.customHandlers.set(t.type, t);
		this.fallbackNodeTypeName = e.fallbackBlockConfig?.nodeTypeName;
	}
	serialize(e) {
		if (e.type.name !== "doc") throw Error("Must provide an entire document to serialize");
		return this.serializeFragment(e.content);
	}
	serializeSlice(e) {
		return this.serializeFragment(e.content);
	}
	serializeFragment(e) {
		let t = [];
		return e.forEach((e) => {
			let n = this.serializeBlock(e);
			n && t.push(n);
		}), new i(t);
	}
	serializeBlock(t) {
		if (this.fallbackNodeTypeName && t.type.name === this.fallbackNodeTypeName) {
			let e = t.attrs.originalData;
			return e && typeof e == "object" ? e : { type: t.attrs.originalType || "unknown" };
		}
		let n = t.attrs.type, r = this.customHandlers.get(n);
		if (r) return r.serialize(t, this);
		switch (t.attrs.type) {
			case e.PARAGRAPH:
			case e.HEADING:
			case e.SUBHEADING:
			case e.SUBHEADING3:
			case e.SUBHEADING4:
			case e.SMALL:
			case e.CODE: return this.serializeTextBlock(t);
			case e.IF_ELSE_STATEMENT: return this.serializeIfElseStatement(t);
			case e.IMAGE: return this.isIncompleteUpload(t.attrs.src) ? void 0 : this.serializeAsImage(t);
			case e.IMAGE_TEXT: return this.serializeAsImageText(t);
			case e.ORDERED_LIST:
			case e.UNORDERED_LIST: return this.serializeAsList(t);
			case e.VIDEO: return this.serializeAsVideo(t);
			case e.VIDEO_FILE: return this.serializeAsVideoFile(t);
			case e.AUDIO_FILE: return this.serializeAsAudioFile(t);
			case e.BUTTON: return this.serializeAsButton(t);
			case e.HORIZONTAL_RULE: return this.serializeAsHorizontalRule(t);
			case e.MESSENGER_CARD: return this.serializeAsMessengerCard(t);
			case e.TABLE: return this.serializeAsTable(t);
			case e.ORDERED_NESTED_LIST:
			case e.UNORDERED_NESTED_LIST: return this.serializeAsNestedList(t);
			case e.HTML: return this.serializeHtmlBlock(t);
			case e.TWITTER_FOLLOW_BUTTON: return this.serializeTwitterFollowButton(t);
			case e.FACEBOOK_LIKE_BUTTON: return this.serializeFacebookLikeButton(t);
			case e.SOCIAL: return this.serializeAsSocial(t);
			case e.SPACER: return this.serializeAsSpacer(t);
			case e.CALLOUT: return this.serializeCallout(t);
			case e.COLLAPSIBLE_SECTION: return this.serializeAsCollapsibleSection(t);
			case e.UNSUPPORTED_ELEMENT: return this.serializeAsUnsupportedElement(t);
		}
	}
	serializeTwitterFollowButton(e) {
		let t = e.attrs;
		return {
			type: t.type,
			username: t.username
		};
	}
	serializeFacebookLikeButton(e) {
		let t = e.attrs;
		return {
			type: t.type,
			url: t.url
		};
	}
	isHeadingBlock(e) {
		return e.type === "heading" || e.type === "subheading" || e.type === "subheading3" || e.type === "subheading4";
	}
	serializeTextBlock(e) {
		let t = e.attrs, n = {
			type: t.type,
			text: ""
		};
		return this.addAlignment(n, e), this.addStyle(n, e), n.type === "paragraph" && this.config.allowEmptyParagraphs && (n.allowEmpty = !0), n.type === "paragraph" && !this.config.allowImplicitMarginParagraphs && (n.class = r), n.text = new o(this.schema, this.config).serializeNode(e), this.isHeadingBlock(n) && (n.idAttribute = t.idAttribute), n;
	}
	serializeHtmlBlock(e) {
		let t = e.attrs, n = {
			type: t.type,
			content: "",
			header: null,
			footer: null
		};
		return n.content = t.content ?? "", n;
	}
	serializeIfElseStatement(e) {
		let t = e.attrs;
		return {
			type: t.type,
			fallbackBlocks: t.fallbackBlocks ?? [],
			predicatesBlocksPairs: t.predicatesBlocksPairs ?? []
		};
	}
	serializeAsImage(e) {
		let t = e.attrs, n = {
			type: t.type,
			url: ""
		};
		return this.addAlignment(n, e), n.url = t.src, t.linkUrl && (n.linkUrl = t.linkUrl), t.width && (n.width = Number(t.width)), t.height && (n.height = Number(t.height)), t.displayWidth && (n.displayWidth = Number(t.displayWidth)), t.text && (n.text = t.text), n;
	}
	serializeAsImageText(e) {
		let t = e.attrs;
		return {
			type: t.type,
			imageUrl: t.imageUrl ?? "",
			title: t.title,
			text: t.text
		};
	}
	serializeAsList(e) {
		let t = {
			type: e.attrs.type,
			items: []
		};
		return this.addStyle(t, e), e.content.forEach((e) => {
			t.items.push(new o(this.schema, this.config).serializeNode(e.content.firstChild));
		}), t;
	}
	serializeAsNestedList(e) {
		let t = e.attrs, n = [];
		return e.content.forEach((e) => {
			n.push(this.serializeAsNestedListItem(e));
		}), {
			type: t.type,
			items: n
		};
	}
	serializeAsNestedListItem(e) {
		let t = [];
		return e.content.forEach((e) => {
			let n = this.serializeBlock(e);
			n && t.push(n);
		}), { content: t };
	}
	serializeAsVideo(e) {
		let t = e.attrs;
		return {
			type: t.type,
			provider: t.provider,
			id: t.id
		};
	}
	serializeAsVideoFile(e) {
		let t = e.attrs;
		return {
			type: t.type,
			thumbnailUrl: t.thumbnailUrl,
			url: t.url,
			captions: t.captions
		};
	}
	serializeAsAudioFile(e) {
		let t = e.attrs;
		return {
			type: t.type,
			url: t.url
		};
	}
	serializeAsButton(e) {
		let t = e.attrs, n = a(t.text);
		n = n.replace(/&quot;/g, "\"");
		let r = {
			type: t.type,
			text: n,
			linkUrl: t.linkUrl,
			buttonStyle: t.buttonStyle
		};
		return this.addAlignment(r, e), this.addStyle(r, e), this.addPadding(r, e), r;
	}
	serializeAsHorizontalRule(e) {
		let t = {
			type: e.attrs.type,
			text: n
		};
		return this.addNodeWidth(t, e), this.addBorderStyles(t, e), t;
	}
	serializeAsMessengerCard(e) {
		let t = e.attrs;
		return {
			type: "messengerCard",
			canvas: t.canvas,
			text: t.text,
			messenger_app_id: t.messenger_app_id,
			uri: t.uri
		};
	}
	serializeAsTable(e) {
		let t = e.attrs, n = [], r = t.container, i = t.responsive;
		e.content.forEach((e) => {
			n.push(this.serializeAsTableRow(e, r));
		});
		let a = {
			type: t.type,
			responsive: t.responsive,
			container: r,
			rows: n
		};
		return typeof t.stacked == "boolean" && (a.stacked = t.stacked), (r || i) && (this.addStyle(a, e), this.addPadding(a, e)), t.sectionType && (a.sectionType = t.sectionType), a;
	}
	serializeAsTableRow(e, t) {
		let n = [];
		return e.content.forEach((e) => {
			n.push(this.serializeAsTableCell(e, t));
		}), { cells: n };
	}
	serializeAsTableCell(e, t) {
		let n = e.attrs, r = [];
		e.content.forEach((e) => {
			let t = this.serializeBlock(e);
			t && r.push(t);
		});
		let i = { content: r };
		return t && this.addPadding(i, e), t || this.addBackgroundColor(i, e), n.colwidth && n.colwidth.length > 0 && (i.displayWidth = n.colwidth[0]), i;
	}
	serializeAsSocial(e) {
		let t = e.attrs, n = {
			type: t.type,
			items: t.items ?? []
		};
		return this.addAlignment(n, e), n;
	}
	serializeAsSpacer(e) {
		let t = e.attrs;
		return {
			type: t.type,
			height: t.height
		};
	}
	serializeCallout(e) {
		let t = e.attrs, n = [];
		return e.content.forEach((e) => {
			let t = this.serializeBlock(e);
			t && n.push(t);
		}), {
			type: t.type,
			content: n,
			style: {
				backgroundColor: t.backgroundColor,
				borderColor: t.borderColor
			}
		};
	}
	serializeAsUnsupportedElement(e) {
		let t = e.attrs;
		return {
			type: t.type,
			unsupportedTypeName: t.unsupportedTypeName,
			text: t.text,
			category: "unsupported"
		};
	}
	serializeAsCollapsibleSection(t) {
		let n = t.attrs, r, i = [];
		return t.content.forEach((t) => {
			let n = t.attrs;
			n.type === e.COLLAPSIBLE_SECTION_SUMMARY ? r = this.serializeCollapsibleSectionSummary(t) : n.type === e.COLLAPSIBLE_SECTION_CONTENT && (i = this.serializeCollapsibleSectionContent(t));
		}), {
			type: n.type,
			summary: r,
			content: i
		};
	}
	serializeCollapsibleSectionSummary(e) {
		let t = {
			type: "paragraph",
			text: ""
		}, n;
		return e.content.firstChild && (n = this.serializeBlock(e.content.firstChild)), n || t;
	}
	serializeCollapsibleSectionContent(e) {
		let t = [];
		return e.content.forEach((e) => {
			let n = this.serializeBlock(e);
			n && t.push(n);
		}), t;
	}
	addAlignment(e, n) {
		let r = n.attrs.alignment;
		r && r !== t && (e.align = r);
	}
	addNodeWidth(e, t) {
		let n = t.attrs.width;
		n && (e.width = n);
	}
	addBackgroundColor(e, t) {
		let n = t.attrs.backgroundColor;
		n && (e.style = {
			...e.style,
			backgroundColor: n
		});
	}
	addBorderStyles(e, t) {
		if (this.config.customStylesConfig?.allowCustomStyles) {
			let { borderColor: n, borderStyle: r, borderWidth: i } = t.attrs;
			(n || r || i) && (e.style = {
				...e.style,
				...n && { borderColor: n },
				...r && { borderStyle: r },
				...i && { borderWidth: i }
			});
		}
	}
	addStyle(e, t) {
		if (this.config.customStylesConfig?.allowCustomStyles) {
			let { fontFamily: n, fontColor: r, backgroundColor: i, borderRadius: a } = t.attrs;
			(n || r || i || a) && (e.style = {
				...e.style,
				...n && { fontFamily: n },
				...r && { fontColor: r },
				...i && { backgroundColor: i },
				...a && { borderRadius: a }
			});
		}
	}
	addPadding(e, t) {
		if (this.config.customStylesConfig?.allowCustomStyles) {
			let { paddingTop: n, paddingBottom: r, paddingLeft: i, paddingRight: a } = t.attrs;
			(n || r || i || a) && (e.style = {
				...e.style,
				...n && { paddingTop: n },
				...r && { paddingBottom: r },
				...i && { paddingLeft: i },
				...a && { paddingRight: a }
			});
		}
	}
	isIncompleteUpload(e) {
		return e.startsWith("blob");
	}
};
//#endregion
export { s as BlocksSerializer };
